module.exports = __webpack_public_path__ + "img/phone.cd5aaa93.svg";